import { useCallback, useEffect } from 'react';

/**
 * Custom hook for handling escape key press to close modals
 * @param {Function} onClose - Function to call when escape is pressed
 * @param {boolean} isOpen - Whether the modal is open
 */
const useEscapeKey = (onClose, isOpen = true) => {
   const handleEscapeKey = useCallback((event) => {
      if (event.key === 'Escape' && isOpen) {
         onClose();
      }
   }, [onClose, isOpen]);

   useEffect(() => {
      if (isOpen) {
         window.addEventListener('keydown', handleEscapeKey);
         return () => window.removeEventListener('keydown', handleEscapeKey);
      }
   }, [handleEscapeKey, isOpen]);
};

export default useEscapeKey;